










// Vue
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

// Third party
import dayjs from 'dayjs';
import 'dayjs/locale/es';

// Constants
import Assets from '@/constants/assets.ts';
import Constants from '@/constants/constants.ts';
import RouteNames from '@/constants/route-names';

// Components
import Btn, {
  BtnColor,
  BtnWidth,
  BtnHeight,
  BtnFontSize,
  BtnPredefinedStyle,
} from '@/shared/components/btn.component.vue';
import ItemThumb, {
  ItemThumbPrefeginedStyle,
  TittleFontFamily,
  SubtitleFontFamily,
} from '@/shared/components/item-thumb.component.vue';
import Icon, { IconEnum } from '@/shared/components/icon.component.vue';
import Modal, {
  ModalTitleColor,
} from '@/shared/components/Modal.component.vue';
import TextArea, {
  TextareaPredefinedStyle,
} from '@/shared/components/text-area.component.vue';
import InlineSpinner, {
  SpinnerSize,
} from '@/shared/components/inline-spinner.component.vue';
import Checkbox, {
  CheckboxPredefinedStyle,
} from '@/shared/components/checkbox.component.vue';
import FieldSet from '@/shared/components/field-set.component.vue';

// Views
import FormView from '@/shared/views/form.view.vue';
import FeesInfo from '@/client/budget/views/acceptance/fees-info/index.vue';
import PaymentMethodCard from '@/client/budget/views/acceptance/choose-payment-method/payment-method-card/index.vue';
import PaymentMethodDirectDebit from '@/client/budget/views/acceptance/choose-payment-method/payment-method-direct-debit/index.vue';
import PaymentMethodWireTransfer from '@/client/budget/views/acceptance/choose-payment-method/payment-method-wire-transfer/index.vue';
import BillingData from '@/client/budget/views/acceptance/choose-payment-method/billing-data/index.vue';

// Models
import { Product } from '@/manager/product/models/product.model';
import { BudgetPaymentMethod } from '@/manager/budget/models/budget.model';

// Filters
import round from '@/shared/filters/round.filter.ts';
import formatDate from '@/shared/filters/formatDate.filter.ts';

// Services
import BudgetService from '@/manager/budget/budget.service';

enum ProductTitleColor {
  LightGreen = 'product-container__title--light-green',
  Secondary = 'product-container__title--secondary',
  FlReen = 'product-container__title--fl-green',
  FlGreenMiddle = 'product-container__title--fl-green-middle',
}

@Component({
  components: {
    Btn,
    BillingData,
    FeesInfo,
    FieldSet,
    FormView,
    Icon,
    ItemThumb,
    Modal,
    PaymentMethodCard,
    PaymentMethodDirectDebit,
    PaymentMethodWireTransfer,
    TextArea,
    InlineSpinner,
    Checkbox,
  },
  computed: {
    ...mapGetters({
      currentBudget: 'getCurrentBudgetAcceptance',
      getFeeList: 'getFeeList',
      acceptanceProductList: 'getCurrentBudgetAcceptanceProductList',
      acceptanceProductListContained:
        'getCurrentBudgetAcceptanceProductListContained',
      getConvocationList: 'getCurrentBudgetAcceptanceConvocationByProduct',
      selectedConvocations: 'getCurrentBudgetAcceptanceSelectedConvocations',
      productConvocationList:
        'getCurrentBudgetAcceptanceProductsWithConvocation',
      isCardMethodSelected: 'isCardMethodSelectedInCurrentBudgetAcceptance',
      isDirectDebitMethodSelected:
        'isDirectDebitMethodSelectedInCurrentBudgetAcceptance',
      isSendWireTransferMethodSelected:
        'isWireTransferMethodSelectedInCurrentBudgetAcceptance',
      budgetTotalPrice: 'getCurrentBudgetAcceptanceTotalPrice',
    }),
  },
  filters: {
    round,
    formatDate,
  },
})
export default class Summary extends Vue {
  @Prop({ default: false }) private validation!: boolean;

  private assets = Assets;
  private constants = Constants;
  private checkboxPredefinedStyle = CheckboxPredefinedStyle;
  private spinnerSize = SpinnerSize;
  private textareaPredefinedStyle = TextareaPredefinedStyle;
  private modalTitleColor = ModalTitleColor;
  private itemThumbPrefeginedStyle = ItemThumbPrefeginedStyle;
  private btnColor = BtnColor;
  private btnPredefinedStyle = BtnPredefinedStyle;
  private btnWidth = BtnWidth;
  private btnHeight = BtnHeight;
  private btnFontSize = BtnFontSize;
  private tittleFontFamily = TittleFontFamily;
  private subtitleFontFamily = SubtitleFontFamily;
  private currentBudget!: any;
  private getFeeList!: any;
  private budgetTotalPrice!: any;
  private acceptanceProductListContained!: any;
  private acceptanceProductList!: any;
  private updateAcceptanceProductList!: any;
  private setAcceptanceProductList!: any;
  private getConvocationList!: any;
  private productConvocationList!: any;
  private selectedConvocations!: any;
  private isCardMethodSelected!: any;
  private isDirectDebitMethodSelected!: any;
  private isSendWireTransferMethodSelected!: any;
  private serverError = '';
  private requestPending = false;
  private iconEnum = IconEnum;
  private addObservationModalOpened = false;
  private rejectBudgetModalOpened = false;
  // private clientPaymentSelected:any = this.currentBudget && this.currentBudget.creditCard? this.currentBudget.creditCard : this.currentBudget && this.currentBudget.bankAccount? this.currentBudget.bankAccount:'';
  private literals = {
    title: 'Resumen de la aceptación de tu alta',
    subtitle:
      'Comprueba que los datos de la aceptación del alta de tus productos  antes de enviar:',
    modal: {
      title: 'Ya casi estamos…',
      subtitle:
        'Estás a punto de completar la aceptación del alta de tu compra. ' +
        'Puedes añadir una observación para cualquier aspecto que creas necesario hacernos llegar:',
      placeholder: 'Añade un comentario a la aceptación del alta',
      btnRight: 'Confirmar y terminar',
      btnLeft: 'Modificar datos',
    },
    checkbox: {
      sectionText: 'Te sugerimos que leas las ',
      sectionTextLink: 'condiciones del alta',
      label: 'Acepto las condiciones del alta',
    },
    rejectButton: 'Rechazar alta',
    modalRejectBudget: {
      title: 'Rechar alta',
      text: '¿Estás seguro de que quieres rechazar tu alta?',
      btnReject: 'Rechazar',
      btnCancel: 'Cancelar',
    },
  };


  get clientPaymentSelected(){
    if (this.isCardMethodSelected) {
      return this.currentBudget.creditCard
    } else if(this.isDirectDebitMethodSelected){
      return this.currentBudget.bankAccount
    }
  }

  get hasServerError() {
    return this.serverError !== '';
  }

  get creditCardFormated() {
    const creditCard = Object.assign({}, this.currentBudget.creditCard);
    const splittedDate = creditCard.dateExpiration.split('/');
    const month = Number(splittedDate[0]) - 1;

    let dateDayjs = dayjs();
    let year = dateDayjs.year().toString();
    year = year.substring(0, year.length - 2);
    year += splittedDate[1];
    dateDayjs = dateDayjs
      .set('date', 1)
      .set('month', month)
      .set('year', Number(year));
    creditCard.dateExpiration = dateDayjs.toISOString();

    return creditCard;
  }

  get asideBg() {
    return {
      'background-image': `url("${this.assets.navbarAcceptanceBg}")`,
      'background-size': `cover`,
    };
  }
  private getConvocation(product: Product) {
    let convocationSelected;
    this.selectedConvocations.forEach((convocationId: any) => {
      this.getConvocationList(product.id).forEach((convocation: any) => {
        if (convocationId === convocation.id) {
          convocationSelected = convocation;
        }
      });
    });
    return convocationSelected;
  }

  private productTitle(product: Product) {
    const title = { text: '', color: '' };
    if (product !== undefined) {
      // if (product.acronym && product.acronym.includes('TLP')) {
      //   title.text = 'TLP';
      //   title.color = ProductTitleColor.FlReen;
      // } else if (product.level > 3 || product.level === null) {
      //   title.text = 'Especialización';
      //   title.color = ProductTitleColor.LightGreen;
      // } else if (product.level <= 3) {
      //   title.text = `Curso N.${product.level}`;
      //   // title.text = '';
      //   title.color = ProductTitleColor.LightGreen;
      // }
      title.text = product.name;
      title.color = ProductTitleColor.FlReen;
    }
    return title;
  }

  private locationName(convocation: any) {
    let name = '';
    if (convocation && convocation.location) {
      name = convocation.location.name;
    }
    return name;
  }

  private convocationDate(convocation: any) {
    let date = '';
    if (convocation && convocation.timetables) {
      date = convocation.timetables[0].date;
    }
    return date;
  }

  private goToStep(step: string) {
    this.$router.push({
      name: RouteNames.BudgetAcceptance,
      params: {
        id: this.currentBudget.id,
        step,
      },
    });
  }

  private back() {
    this.goToStep('1');
  }

  private setObservationModalVisibility(value: boolean) {
    this.addObservationModalOpened = value;
  }

  private setServerError(err: any) {
    this.serverError = Constants.internalServerErrorMessage;
  }

  private getPaymentInfo() {
    let info = {};
    if (this.isCardMethodSelected) {
      info = { creditCard: this.creditCardFormated };
    } else if (this.isDirectDebitMethodSelected) {
      // const bankId = this.currentBudget.bankAccount.bank.id;
      // this.currentBudget.bankAccount.bank = bankId;
      if (process.env.VUE_APP_DEBUG) {
        // this.currentBudget.bankAccount.bank = "572a9108-f910-4cb6-942c-cedb529e29e3";
        this.currentBudget.bankAccount.bank = "ec3215aa-a207-457a-865b-dca79c864263";
      } else {
        // this.currentBudget.bankAccount.bank = "7591c2a8-691c-4862-aa57-fc374e9117a2";
        this.currentBudget.bankAccount.bank = "ec3215aa-a207-457a-865b-dca79c864263";
      }
      info = { bankAccount: this.currentBudget.bankAccount };
    }
    return info;
  }

  private getBillData() {
    const data = {
      billFiscalData: false,
      bill: this.currentBudget.bill,
    };
    return data;
  }

  private finishAcceptance() {
    this.$store
      .dispatch('finishCurrentBudgetAcceptance', {
        budgetId: this.currentBudget.id,
        convocation: this.selectedConvocations,
        feeNumber: this.currentBudget.numberOfFees,
        feeList: this.currentBudget.getFeeList,
        paymentMethod: this.currentBudget.paymentMethod,
        budgetSepaInfo: this.currentBudget.budgetSepaInfo,
        note: this.currentBudget.note,
        ...this.getBillData(),
        ...this.getPaymentInfo(),
      })
      .then(
        (res) => {
          this.requestPending = false;
          this.setObservationModalVisibility(false);
        },
        (err) => {
          this.requestPending = false;
          this.setServerError(err);
        },
      );
  }

  private sendForm() {
    this.requestPending = true;
    this.finishAcceptance();
  }

  private setRejectBudgetModalOpened(value: boolean) {
    this.rejectBudgetModalOpened = value;
  }

  private rejectBudget() {
    BudgetService.rejectBudget(this.currentBudget.id).then((res) => {
      this.$router.go(0);
    });
  }
}
